/**
 * Re-throws the value if it is already an Error instance (preserving FetchError
 * context such as message and HTTP status), otherwise wraps it in a new Error.
 *
 * Intended for the openapi-fetch `{ data, error }` pattern where the error
 * object may already be a FetchError produced by the auth middleware.
 */
export function throwOnError(error: unknown): never {
  if (error instanceof Error) throw error
  throw new Error('API request failed')
}
